<template>
	<div class="box mb-0 w-100">
		<table class="table mb-0">
			<tbody>
				<tr>
					<td class="text-muted _600">Scores</td>
					<td v-for="deliv in deliveries" :key="deliv.id" class="b-l text-center v-mid">{{ deliv.name }}</td>
				</tr>
				<!-- <tr v-if="!hideTime">
					<td colspan="3">
						<i class="fal fa-clock"></i> {{format(mut_score.created_at)}}
					</td>
				</tr>-->
				<template v-if="!loading" v-for="(ts, i) in combinedTraitScores">
					<tr :key="`score-${i}`">
						<td class="v-mid">
							<strong>{{ ts.traitName }}</strong>
						</td>
						<td v-for="(score, i) in ts.scores" :key="i" class="text-center v-mid b-l text-md p-custom p-0">
							<div class="d-flex flex-row align-items-center">
								<div
									v-if="score.delta != undefined"
									class="flex text-right p-1"
									:class="{
										'text-extra-muted': score.score == '—',
										[progressClass(score.delta)]: true
									}"
								>
									{{ score.score }}
								</div>
								<div
									v-if="score.delta != undefined"
									class="flex text-left p-1"
									:class="{
										'text-extra-muted': score.score == '—',
										[progressClass(score.delta)]: true
									}"
								>
									<i
										v-if="progressIcon(score.delta)"
										class="far text-muted"
										:class="progressIcon(score.delta)"
									/>
								</div>
								<div
									v-if="score.delta == undefined"
									class="flex text-center p-1"
									:class="{
										'text-extra-muted': score.score == '—',
										[progressClass(score.delta)]: true
									}"
								>
									{{ score.score }}
								</div>
							</div>
						</td>
					</tr>
				</template>
				<tr v-if="loading">
					<td>
						<loading v-if="!loadingError" type="header" />
						<div v-if="loadingError">Error</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Utils from "@/services/Utils";
import fs from "@/services/FormatService";
import moment from "moment";

export default {
	name: "ProgressScore",
	props: {
		responses: true,
		deliveries: true,
		rubric: true,
		hideTime: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			fs: fs,
			loading: false,
			loadingError: null,

			numAgreed: 0,
			numTraits: 0
		};
	},
	created() {},
	mounted() {},
	computed: {
		firstScore() {
			if (!this.responses[0]) {
				return null;
			}
			return this.responses[0].final_score;
		},
		secondScore() {
			if (!this.responses[1]) {
				return null;
			}
			return this.responses[1].final_score;
		},
		resScore() {
			if (!this.responses[2]) {
				return null;
			}
			return this.responses[2].final_score;
		},
		combinedTraitScores() {
			let traitScores = {};
			_.each(this.deliveries, deliv => {
				let resp = _.find(this.responses, { delivery_id: deliv.id });

				_.each(this.rubric.traits, trait => {
					if (trait.separator) {
						return;
					}

					if (!traitScores[trait.id]) {
						traitScores[trait.id] = [];
					}

					let cell = { score: "—" };

					if (resp && resp.final_score) {
						let score = _.find(resp.final_score.trait_scores, {
							trait_id: trait.id
						});
						if (score) {
							cell.score = score.score;
							let len = traitScores[trait.id].length;
							if (len > 0) {
								let prev = traitScores[trait.id][len - 1];
								if (prev.score != "—") {
									cell.delta = cell.score - prev.score;
								}
							}
						}
					}

					traitScores[trait.id].push(cell);
				});
			});

			let scoreRows = [];
			_.each(this.rubric.traits, trait => {
				if (trait.separator) {
					return;
				}

				let scoreRow = traitScores[trait.id];
				if (scoreRow) {
					scoreRows.push({
						traitName: trait.name,
						scores: scoreRow
					});
				}
			});

			return scoreRows;
		}
	},
	watch: {},
	methods: {
		scoreTypeIcon(scoreType) {
			return fs.scoreTypeIcon(scoreType);
		},
		scoreTypeIconClass(scoreType) {
			return fs.scoreTypeIconClass(scoreType);
		},
		scoreTypeStr(scoreType) {
			let ret = fs.scoreTypeName(scoreType);
			if (this.hasUser) {
				return `${ret}:`;
			} else {
				return ret;
			}
		},
		scoreTypeTooltip(score) {
			let tooltip = `<strong>${this.scoreTypeStr(score.score_type)} Score</strong>`;
			tooltip += `<br /><span class="text-muted"><i class="fal fa-clock"></i> ${fs.fullDate(
				score.created_at
			)}</span>`;

			return tooltip;
		},
		getTraitName(id) {
			if (this.rubric) {
				var trait = _.find(this.rubric.traits, {
					id: id
				});
				if (trait) {
					return trait.name;
				}
			}

			return "——";
		},
		getMetaTraitName(id) {
			if (this.rubric) {
				var trait = _.find(this.rubric.meta_traits, {
					id: id
				});
				if (trait) {
					return trait.name;
				}
			}

			return "——";
		},
		isRequiredMetaTrait(meta_trait) {
			if (this.rubric) {
				var trait = _.find(this.rubric.meta_traits, {
					id: meta_trait.meta_trait_id
				});
				if (trait) {
					return trait.required;
				}
			}

			return false;
		},
		getScore(ts) {
			if (ts.score >= 0) {
				return ts.score;
			} else {
				return ts.condition;
			}
		},
		messageUser() {
			this.$emit("on-message", this.score);
		},
		resetScore() {
			this.$emit("on-reset", this.score);
		},

		progressClass(delta) {
			if (delta == undefined) {
				return "";
			}

			if (delta < 0) {
				return "text-danger";
			} else if (delta > 0) {
				return "text-success";
			} else {
				return "text-warning";
			}
		},

		progressIcon(delta) {
			if (delta == undefined) {
				return "";
			}

			if (delta < -1) {
				return "fa-chevron-double-down";
			} else if (delta < 0) {
				return "fa-chevron-down";
			} else if (delta > 1) {
				return "fa-chevron-double-up";
			} else if (delta > 0) {
				return "fa-chevron-up";
			} else {
				return "";
			}
		}
	}
};
</script>

<style scoped>
.list-group-item:hover {
	background-color: rgba(0, 0, 0, 0.05);
}
.decreased {
	background-color: rgb(255, 0, 0, 0.2);
	border-radius: 0.5rem;
}
.unchanged {
	background-color: rgba(253, 168, 41, 0.25);
	border-radius: 0.5rem;
}
.increased {
	background-color: rgba(34, 182, 110, 0.25);
	border-radius: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressScore.vue